document.addEventListener('DOMContentLoaded', function() {
  const stepsSliders = document.querySelectorAll('.steps-slider__swiper');
  
  stepsSliders.forEach(function(slider) {
    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      loopAdditionalSlides: 2,
      updateOnWindowResize: true,
      observer: true,
      observeParents: true,
      scrollbar: {
        el: slider.querySelector('.steps-slider__scrollbar'),
        draggable: true,
        snapOnRelease: true,
        hide: false,
      },
      breakpoints: {
        769: {
          slidesPerView: 3,
          spaceBetween: 20,
          loop: false,
          allowTouchMove: true, // Changed from false to true
          scrollbar: {
            el: slider.querySelector('.steps-slider__scrollbar'),
            draggable: true, // Changed from false to true
            hide: false, // Changed from true to false
          }
        }
      }
    });

    const totalSlides = swiper.slides.length;
    const delay = 4000; // 5 seconds delay

    function autoSlide() {
      if (swiper.isEnd) {
        swiper.slideTo(0, 0); // Go to the first slide instantly
      } else {
        swiper.slideNext();
      }

      setTimeout(autoSlide, delay);
    }

    // Start the auto-sliding
    setTimeout(autoSlide, delay);
  });
});
